import { Typography, TypographyProps } from '@/primitives';
import { slate } from '@/lib/colours';
import { ReactNode } from 'react';

type TOwnProps = TypographyProps & {
  children?: ReactNode;
};

export const PageHeading = (props: TOwnProps) => {
  const { children, ...rest } = props;
  return (
    <Typography {...rest} variant="headlinemedium" color={slate[900]}>
      {children}
    </Typography>
  );
};
